module.exports = __webpack_public_path__ + "static/princess-0610ec1dd06d5c16132dd25095e602c4.svg";